module.exports = __webpack_public_path__ + "static/media/ecThumbnail12.93179c57.jpg";